exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".modal-4d9e3>div>button>span{display:flex;justify-content:center;align-items:center}.technologiesTable-c38bf{background-color:#fff;box-shadow:0 0 3px #ccc;border-radius:4px}", ""]);

// Exports
exports.locals = {
	"modal": "modal-4d9e3",
	"technologiesTable": "technologiesTable-c38bf"
};